import React, { useState,useEffect } from 'react';
import { Button, Steps, Form, Input, Select,Radio,DatePicker,message,AutoComplete} from 'antd/lib';
import { useDispatch, useSelector } from "react-redux";
import { CustLife_detail } from '../../Redux/actions/NumLife';
import moment from 'moment';
import {CalendarOutlined } from "@ant-design/icons"
import Male from '../../images/boy-face.png'
import Female from '../../images/female-face.png'
import SmokeImg from '../../assets/cigarette_smoke.png'
import NonSmokeImg from '../../assets/no_smoke.png'

export default function LifeSep1({ setCurrent, current }) {
  console.log(current);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const CusDeatail = useSelector((state) => state?.lifedetail?.cusInfo);
  const [dob, setDob] = useState('');
  const [Age, setAge] = useState(CusDeatail?.Age ? CusDeatail?.Age + 'Years' : '');
  const [AgeInNum, setAgeInNum] = useState(CusDeatail?.Age ? CusDeatail?.Age : '');
  const [gvalue, setValue] = useState(CusDeatail ? CusDeatail?.gender : 'M');
  const [Smokevalue, setSmokeValue] = useState(CusDeatail ? CusDeatail?.IsSmoker : 'N');
  const [loading, setLoading] = useState(false);

  const calculateAge = (date) => {
    console.log(date)
    const dateString = moment(date).format('YYYY-MM-DD');
    console.log(dateString);
  
    setDob(dateString);
    const dobObject = new Date(date);
    console.log(dobObject)
    const ageDifMs = Date.now() - dobObject.getTime();
    console.log(ageDifMs);
    
    const ageDate = new Date(ageDifMs);
    console.log(ageDate);
    
    const ageInYears = Math.abs(ageDate.getUTCFullYear() - 1970).toString(); 
    console.log(ageInYears);
    if(ageInYears === '53') {
        setAge('')
        setAgeInNum('')
    } else {
        setAge(ageInYears +' '+ 'years')
        setAgeInNum(ageInYears)
    }
    console.log(Age)
};

const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, 'years'); 
  
    return current.isAfter(minDate, 'day'); 
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, 'years');
    return minDate;
  }; 

  const onChange = (e) => {
    // setRadioCheck(e.target.checked)
    console.log('radio checked', e.target.value);
    setValue(e.target.value);
  };
  const onChainSmoke = (e) => {
    // setRadioCheck(e.target.checked)
    console.log('radio checked', e.target.value);
    setSmokeValue(e.target.value);
  }; 
  const OnFinish = (values) => {
    console.log(values);
    const UpdateCus = {
      ...CusDeatail,
      gender : gvalue,
      IsSmoker : Smokevalue,
    dateofbirth : moment(values.dateofbirth).format('YYYY-MM-DD'),
    Age : AgeInNum,
    };
    console.log(UpdateCus);
    dispatch(CustLife_detail(UpdateCus));
    setCurrent(current + 1);
  };
  return (
    <>
      <div className="step-container-health d-flex justify-content-center">
      <Form
            layout='vertical'
            form={form}
            style={{ width: "95%" }}
            requiredMark={false}
            onFinish={OnFinish}
            >
            <Form.Item 
            name='gender'
            rules={[
              {  
                  required: true,
                  message: 'please select'
              },
              ]}
              initialValue={gvalue}
              >
              <Radio.Group 
                className='life-gender'
                onChange={onChange} 
                value={gvalue}>
                  <Radio.Button value='M'
                   className={gvalue === 'M' ? `active-button-life` : 'life-gender-rb'}>
                    <span>
                       <img src={Male} className={` ${gvalue === 'M' ? 'remove-filter-life' : 'life-gender-img'}`}/>Male
                    </span>
                    </Radio.Button>
                  <Radio.Button value='F'
                  className={gvalue === 'F' ? `active-button-life` : 'life-gender-rb'}>
                    <span>
                       <img src={Female} className={` ${gvalue === 'F' ? 'remove-filter-life' : 'life-gender-img'}`}/>Female
                    </span>
                  </Radio.Button>
              </Radio.Group>
            </Form.Item>
            <Form.Item
            name='smoker'
            rules={[
              {  
                  required: true,
                  message: 'please select'
              },
              ]}
              initialValue={Smokevalue}
              >
              <Radio.Group 
                className='life-gender'
                onChange={onChainSmoke} 
                value={Smokevalue}>
                  <Radio.Button value='Y'
                  className={Smokevalue === 'Y' ? `active-button-life` : 'life-gender-rb'}>
                    <span>
                       <img src={SmokeImg} className={` ${Smokevalue === 'Y' ? 'remove-filter' : 'health-gender-img'}`}/>Smoker
                    </span>
                    </Radio.Button>
                  <Radio.Button value='N'
                   className={Smokevalue === 'N' ? `active-button-life` : 'life-gender-rb'}>
                    <span>
                       <img src={NonSmokeImg} className={` ${Smokevalue === 'N' ? 'remove-filter' : 'health-gender-img'}`}/>Non Smoker
                    </span>
                  </Radio.Button>
              </Radio.Group>
            </Form.Item>
            <Form.Item
            // {...formItemLayout}
                label="Date of Birth"
                name='dateofbirth'
                rules={[
                {  
                    required: true,
                    message: 'please input DOB'
                },
                ]}
                initialValue={CusDeatail?.dateofbirth ? moment(CusDeatail?.dateofbirth) : null}
            >
            <DatePicker
            disabledDate={disabledDate}
            defaultPickerValue={getDefaultPickerValue()}
            style={{width: "100%",padding: "10px"}}
            suffixIcon={ Age ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '4px', color: '#0000ff94'}}>{Age}</span>
                    <CalendarOutlined />
                </div>
                ) : (
                <CalendarOutlined />
                )
            }
            format="YYYY-MM-DD"
            placeholder="YYYY-MM-DD"
            onChange={(date) => calculateAge(date)}
            />
            </Form.Item>
            <Form.Item >
              <div className='step-btn-health'>
              <Button 
              loading={loading}
              style={{width: "100%"}} 
              type="primary" htmlType="submit">
                Get Started
              </Button>
              </div>
            </Form.Item>
          </Form>
      </div>
    </>
  );
}
